export class NotShowToastError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'NotShowToastError';
  }
}
